import { download } from 'Lib/exportHelper';
import { formatEpochDate } from 'Lib/stringHelpers';
import AdminStore from 'Reducers/store/adminStore';
import { getAdminUsersWithRoleDisplay } from 'Selectors/users';

export const exportAdminUsers = () => {
    const store = AdminStore.getState();
    const adminUsers = getAdminUsersWithRoleDisplay(store);
    let exportString = 'First Name,Last Name,Email,Username,Phone Number,Notes,Role,Locked Status,Last Logon\n';

    adminUsers.forEach(user => {
        const lastLogon = user.LastLogin && user.LastLogin !== '0' ? formatEpochDate(user.LastLogin) : '';
        exportString += `"${user.FirstName}","${user.LastName}","${user.Email}",${user.Username},="${user.Phone}","${user.Notes}","${user.UserRoleDisplay}","${user.IsLocked}","${lastLogon}"\n`;
    });

    download('Lynq_Platform_Admin_Users.csv', exportString);
};